import React, { useState } from "react";
import { Link } from "react-router-dom";
import { authService } from "../../services";
import { useI18n } from "../../i18n";
import { Button, Input } from "../../components/ui";
import Icon from "../../components/ui/Icon";

export default function ForgotPassword() {
  const { t, tx } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (!email) return setError(tx("กรุณากรอกอีเมล", "Please enter email"));
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 6 }}>{t("auth.forgotTitle")}</h1>
      <p className="u-muted u-mb-16">{tx("กรอกอีเมลที่ใช้สมัคร ระบบจะส่งลิงก์ตั้งรหัสผ่านใหม่ให้", "Enter your email and we will send a reset link")}</p>

      {sent ? (
        <div className="card-crm" style={{ background: "var(--c-indigo-50)", borderColor: "var(--c-indigo-300)" }}>
          <div className="u-strong u-mb-8"><Icon name="success" /> {tx("ส่งลิงก์เรียบร้อย", "Reset link sent")}</div>
          <div className="u-fs-13">{tx(`ส่งไปที่ ${email} แล้ว กรุณาตรวจสอบกล่องจดหมาย`, `Sent to ${email}. Please check your inbox.`)}</div>
          <Link to="/auth/login" className="btn-crm btn-primary-crm btn-block-crm u-mt-16">
            {t("action.login")}
          </Link>
        </div>
      ) : (
        <form onSubmit={submit}>
          <Input label={t("common.email")} type="email" value={email} onChange={(event) => setEmail(event.target.value)} />
          {error ? <div className="field-error u-mb-8">{error}</div> : null}
          <Button type="submit" variant="primary" block disabled={loading}>
            {loading ? tx("กำลังส่ง...", "Sending...") : t("action.send")}
          </Button>
        </form>
      )}

      <div className="u-center u-mt-16 u-fs-13">
        <Link to="/auth/login">← {t("action.back")}</Link>
      </div>
    </>
  );
}
